module.exports = __webpack_public_path__ + "static/media/sspc.f5c223e8.png";